export default {
    name: 'TTF is balanced @ hour 12',
    data:
    {
        "id": "bb5cc852-00a4-426a-8cdc-077987945ab9",
        "type": "Composite",
        "title": "TTF is balanced",
        "config": {
            "operator": "Equals",
            "combine_on": "date",
            "left": {
                "id": "05dec632-0b5a-4f9a-b375-05ca58008fe7",
                "type": "Formatter",
                "config": {
                    "type_id": "classify",
                    "lower": -5,
                    "upper": 5,
                    "child": {
                        "id": "1915715b-06e2-4d5c-841e-294140478472",
                        "type": "Single",
                        "config": {
                            "type_id": "linepack",
                            "hub_id": 14,
                            "hour": "12",
                            "start_date": "2025-06-26",
                            "end_date": "2025-08-25"
                        }
                    },
                    "start_date": "2025-06-26",
                    "end_date": "2025-08-25"
                }
            },
            "right": {
                "id": "f2c6aa2d-9305-4743-b5b1-507ca5109d4f",
                "type": "Single",
                "config": {
                    "type_id": "constant_value",
                    "value": 0,
                    "start_date": "2025-06-26",
                    "end_date": "2025-08-25"
                }
            }
        }
    }


}